/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { GrantResponse } from '../../models/grant-response';

export interface GrantControllerGetAll$Params {
  limit: number;
  skip: number;
}

export function grantControllerGetAll(http: HttpClient, rootUrl: string, params: GrantControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GrantResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, grantControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: GrantResponse;
      }>;
    })
  );
}

grantControllerGetAll.PATH = '/grant';
